import React, { useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import {
  // TileRadio, TileRadioGroup,
  GridRow, GridCol, Heading, Checkbox, Alert
} from '@lmig/lmds-react';

import TextInput from '../Components/TextInput';
import { FormContext } from '../FormContext/FormContext';

const Details = () => { 
  const [isPrefilled, setIsPrefilled] = useState(false);
  // values and handleSetValues commented out - no longer used after repairsComplete removal
  const [/* values */, /* handleSetValues */, , , setCanContinue] = useContext(FormContext);
  const [isChecked, setIsChecked] = isPrefilled ? useState(false) : useState(true);

  useEffect(() => {
    const cachedName = localStorage.getItem('contactName');
    const cachedEmail = localStorage.getItem('contactEmail');
    const cachedPhone = localStorage.getItem('contactPhoneNumber');

    const cachedData = cachedName || cachedEmail || cachedPhone;
    if (cachedData) {
      setIsPrefilled(true);
      setIsChecked(false);
    }
  }, []);

  useEffect(() => {
    setCanContinue(isChecked);
  }, [isChecked, setCanContinue]);


  const contactTitle = isPrefilled ? 'Please confirm your contact information' : 'What are your contact details?';

  return (
    <Box style={{ padding: '20px' }}>

      <Heading type='h3-light'>Please enter the claim number</Heading>

      <GridRow gutters>
        <GridCol base={12} md={4}>
          <TextInput valueKey='claimNumber' />
        </GridCol>
      </GridRow>

      {/* <Heading type='h3-light' style={{ marginTop: '64px' }}>What is the total estimate amount?</Heading>

      <p style={{ fontSize: '16px', font: 'roboto regular 16' }}>
        This should include the original estimate, prior supplements and this supplement.
      </p>

      <GridRow gutters>
        <GridCol base={12} md={4}>
          <TextInput valueKey='uiTotalAmount' />
        </GridCol>
      </GridRow> */}

      <Heading type='h3-light' style={{ marginTop: '64px' }}>What is the total amount for this supplement?</Heading>

      <p style={{ fontSize: '16px', font: 'roboto regular 16' }}>
        This does not include the original estimate or any prior supplements.
      </p>

      <GridRow gutters>
        <GridCol base={12} md={4}>
          <TextInput valueKey='uiSupplementAmount' />
        </GridCol>
      </GridRow>

      {/* <Heading type='h3-light' style={{ marginTop: '64px' }}>Have you completed the repairs?</Heading>

      <TileRadioGroup
        labelVisual=""
        name="repairsComplete"
        onChange={(e) => handleSetValues('repairs', e)}
      >
        <GridRow gutters>
          <GridCol base={12} md={4}>
            <TileRadio defaultChecked={values.details.repairsComplete.value === 'Yes'} labelVisual="Yes" value="Yes" />
          </GridCol>
          <GridCol base={12} md={4}>
            <TileRadio defaultChecked={values.details.repairsComplete.value === 'No'} labelVisual="No" value="No" />
          </GridCol>
        </GridRow>
      </TileRadioGroup> */}

      {/* <Heading type='h3-light'>Select all lines of coverage that applys</Heading>

      <TileCheckboxGroup
        labelVisual=""
        name="linesOfCoverage"
        value={coverageToggle}
        messages={setErrorMsg('details', ['linesOfCoverage'])}
        onChange={handleCoverageToggle}
      >
        <GridRow gutters>
          <GridCol base={12} md={4}>
            <TileCheckbox defaultChecked labelVisual="Dwelling" value="dwelling" />
          </GridCol>
          <GridCol base={12} md={4}>
            <TileCheckbox labelVisual="Other structure" value="other-structure" />
          </GridCol>
        </GridRow>
        <GridRow gutters>
          <GridCol base={12} md={4}>
            <TileCheckbox labelVisual="Personal property" value="personal-property" />
          </GridCol>
          <GridCol base={12} md={4}>
            <TileCheckbox labelVisual="Additional living expenses" value="expenses" />
          </GridCol>
        </GridRow>
      </TileCheckboxGroup> */}

      <Heading type='h3-light' style={{ marginTop: '64px' }}>{contactTitle}</Heading>

      {isPrefilled && (
        <Alert highlightType='informative'>
          This information is pre-filled based on your profile or a previous session.
        </Alert>
      )}

      <GridRow gutters='horizontal'>
        <GridCol base={12} md={4}>
          <TextInput valueKey='contactName' />
        </GridCol>
        <GridCol base={12} md={4}>
          <TextInput valueKey='contactEmail' />
        </GridCol>
      </GridRow>

      <GridRow gutters='horizontal'>
        <GridCol base={12} md={4}>
          <TextInput valueKey='contactPhoneNumber' />
        </GridCol>
      </GridRow>

      {isPrefilled && (
        <Checkbox value='confirmation' checked={isChecked}
          onChange={(e) => setIsChecked(e.target.checked)}
          labelVisual='Mark this box if details above are correct' />
      )}

    </Box>
  );
};

export default Details;
